import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import "../../../assets/styles/dashboard.scss";
import { useFileExport } from "../../../hooks/useFileExport";

const QuickSave = () => {
  const [filters, setFilters] = useState({
    terminalEx: "",
    terminalDr: "",
    dayOfWeek: "",
    routeType: "",
    routeNumber: "",
    streetName: "",
    postcode: "",
    cityName: "",
  });

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const formatPostcode = (value) => {
    const digits = String(value ?? "")
      .replace(/\D/g, "")
      .slice(0, 5);
    return digits.length > 2
      ? `${digits.slice(0, 2)}-${digits.slice(2)}`
      : digits;
  };

  const handleClear = () => {
    setFilters({
      terminalEx: "",
      terminalDr: "",
      dayOfWeek: "",
      routeType: "",
      routeNumber: "",
      streetName: "",
      postcode: "",
      cityName: "",
    });
  };

  const { exportFile, isExporting, exportProgress } = useFileExport(
    "/Address/Csv",
    "addresses.csv",
  );

  const handleDownloadCsv = async () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    const qs = queryParams.toString();
    if (!qs) {
      alert(
        "Proszę wprowadzić co najmniej jeden filtr przed eksportem do pliku.",
      );
      return;
    }

    const filtersToExport = Object.fromEntries(
      [...queryParams.entries()].map(([k, v]) => [k, v]),
    );

    try {
      await exportFile(filtersToExport);
    } catch (e) {
      alert("Wystąpił błąd podczas eksportu CSV.");
    }
  };

  return (
    <div className="routes-list-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <h4>Szybki zapis do pliku</h4>
        </Row>
        <Row className="g-4">
          <Col md={6}>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={4} md={3} className="pe-sm-3">
                <Form.Label>Terminal EX</Form.Label>
              </Col>
              <Col xs={12} sm={8} md={8}>
                <Form.Control
                  type="text"
                  placeholder="EX"
                  value={filters.terminalEx}
                  onChange={(e) =>
                    handleFilterChange("terminalEx", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={4} md={3} className="pe-sm-3">
                <Form.Label>Terminal DR</Form.Label>
              </Col>
              <Col xs={12} sm={8} md={8}>
                <Form.Control
                  type="text"
                  placeholder="DR"
                  value={filters.terminalDr}
                  onChange={(e) =>
                    handleFilterChange("terminalDr", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={4} md={3} className="pe-sm-3">
                <Form.Label>Dzień tygodnia</Form.Label>
              </Col>
              <Col xs={12} sm={8} md={8}>
                <Form.Select
                  value={filters.dayOfWeek}
                  onChange={(e) =>
                    handleFilterChange("dayOfWeek", e.target.value)
                  }
                >
                  <option value="">--Wybierz--</option>
                  <option value="PN">Poniedziałek</option>
                  <option value="WT">Wtorek</option>
                  <option value="SR">Środa</option>
                  <option value="CZ">Czwartek</option>
                  <option value="PT">Piątek</option>
                  <option value="SB">Sobota</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={4} md={3} className="pe-sm-3">
                <Form.Label>Trasa</Form.Label>
              </Col>
              <Col xs={12} sm={4} md={3}>
                <Form.Select
                  value={filters.routeType}
                  onChange={(e) =>
                    handleFilterChange("routeType", e.target.value)
                  }
                >
                  <option value="">-----</option>
                  <option value="EX">EX</option>
                  <option value="DR">DR</option>
                  <option value="W">W</option>
                </Form.Select>
              </Col>
              <Col xs={12} sm={4} md={3}>
                <Form.Control
                  type="text"
                  placeholder="Trasa"
                  value={filters.routeNumber}
                  onChange={(e) =>
                    handleFilterChange("routeNumber", e.target.value)
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-3">
                <Form.Label>Ulica</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="Ulica"
                  value={filters.streetName}
                  onChange={(e) =>
                    handleFilterChange("streetName", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Kod pocztowy</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="__-___"
                  inputMode="numeric"
                  value={filters.postcode || ""}
                  onChange={(e) =>
                    handleFilterChange(
                      "postcode",
                      formatPostcode(e.target.value),
                    )
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Miejscowość</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="Miejscowość"
                  value={filters.cityName}
                  onChange={(e) =>
                    handleFilterChange("cityName", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2">
              <div className="d-flex">
                <Button
                  className="dashboard-optional-button me-2"
                  onClick={handleClear}
                >
                  Wyczyść
                </Button>
                <Button
                  className="dashboard-only-button quick-save-download-button"
                  onClick={handleDownloadCsv}
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Pobieranie...
                      {exportProgress > 0 ? ` ${exportProgress}%` : ""}
                    </>
                  ) : (
                    "Pobierz"
                  )}
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default QuickSave;
